import { defineMessage } from 'services/localization';

export const messages = {
    bankAccountName: defineMessage('bank_account_holder_name'),
    accountNumber: defineMessage('account_number'),
    bicSwift: defineMessage('bic_swift_code'),
    address: defineMessage('address'),
    city: defineMessage('city'),
    country: defineMessage('country'),
    postalCode: defineMessage('postal_code'),
    stateOrProvince: defineMessage('state_province'),
    firstName: defineMessage('first_name'),
    lastName: defineMessage('last_name'),
    companyName: defineMessage('company_name'),
    sortCode: defineMessage('sort_code'),
    aba: defineMessage('aba_american_bankers_association_routing_number'),
    bsb: defineMessage('bsb_bank_state_branch_number'),
    institutionNumber: defineMessage('institution_number'),
    incorporationNumber: defineMessage('incorporation_number'),
    bankCode: defineMessage('bank_code'),
    branchCode: defineMessage('branch_code'),
    clabe: defineMessage('clabe_clave_bancaria_estandarizada_code'),
    cnaps: defineMessage('cnaps_china_national_advanced_payment_system_code'),
    iban: defineMessage('iban'),
    ifsc: defineMessage('ifsc_code'),
    inputPlaceholder: defineMessage('enter_value_1'),
    validationErrorMessage: defineMessage('invalid_value'),
    bankAccountNameValidationError: defineMessage('bank_account_name_shoul_llowing_restrictedchars'),
};
